import React, { useEffect, useState } from "react"
import { Navigate, Outlet, useOutletContext } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setUser } from "@services/global-slice"
import { GlobalProps } from "../../../layout/router/router.types"
import { Loading } from "../../../app/components/loading"

import { isAuthorizedService } from "../../../app/auth/auth-service"

export const fetchUser = async () => {
  const user = await isAuthorizedService()
  let authUser
  if (user?.uid) {
    const reminderInfo = {
      email: user?.email,
      phone: user?.phone,
      deviceid: user?.deviceid,
      disabled: user?.disabled,
    }

    authUser = { ...user, reminderInfo }
    return authUser
  }
}

const ProtectedRoutes = () => {
  const [auth, setAuth] = useState({ user: null, loading: true })
  const dispatch = useDispatch()
  const parentContext = useOutletContext<GlobalProps>()

  useEffect(() => {
    fetchUser().then((authUser) => {
      setAuth({ user: authUser, loading: false })
      dispatch(setUser(authUser))
    })
  }, [dispatch])

  if (auth.loading) return <Loading />
  if (!auth.loading && !auth.user) return <Navigate to="/" replace />

  return <Outlet context={{ ...parentContext, auth, setAuth, fetchUser }} />
}

export default ProtectedRoutes
